import { render, staticRenderFns } from "./shexiang.vue?vue&type=template&id=315a1ffa&"
import script from "./shexiang.vue?vue&type=script&lang=ts&"
export * from "./shexiang.vue?vue&type=script&lang=ts&"
import style0 from "./shexiang.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports